import React from 'react';
import { Switch } from 'react-router-dom';
import { ContentRoute } from 'src/_metronic/layout';
import UsersDetail from './Forms/UsersDetail';
import Consult from './Consult/Consult';
import Reports from './Reports/Reports';
import RecordsList from './Records/RecordsList';
import { useSelector } from 'react-redux';
import { authentication } from '../Authentication';

const UsersManagementPage = () => {
	const user = useSelector((state) => state.auth.user);

	return (
		<Switch>
			<React.Fragment>
				{/* TODOS LOS SUBMODULOS DE ADMIN DE USUARIOS */}
				{authentication.hasRole(
					['ADMINISTRADOR GENERAL', 'OPERADOR DE SEGURIDAD'],
					user
				) ? (
					<div>
						<ContentRoute
							path="/administracion-de-usuarios/nuevo-usuario"
							component={UsersDetail}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/editar-usuario"
							component={Consult}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/reportes"
							component={Reports}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/usuario/:id"
							component={UsersDetail}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/bitacora-de-accesos"
							component={RecordsList}
						/>
						{/* FIN TODOS LOS SUBMODULOS DE ADMIN DE USUARIOS */}
					</div>
				) : (
					''
				)}
				{authentication.hasRole(['SISTEMA'], user) ? (
					<div>
						<ContentRoute
							path="/administracion-de-usuarios/reportes"
							component={Reports}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/bitacora-de-accesos"
							component={RecordsList}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/usuario/:id"
							component={UsersDetail}
						/>
					</div>
				) : (
					''
				)}
				{authentication.hasRole(['RESPONSABLE CASIA'], user) ? (
					<div>
						<ContentRoute
							path="/administracion-de-usuarios/editar-usuario"
							component={Consult}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/usuario/:id"
							component={UsersDetail}
						/>
					</div>
				) : (
					''
				)}

				{authentication.hasRole(
					['RESPONSABLE DE ORGANO COLEGIADO', 'RESPONSABLE DE SEGUIMIENTO'],
					user
				) ? (
					<div>
						<ContentRoute
							path="/administracion-de-usuarios/editar-usuario"
							component={Consult}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/usuario/:id"
							component={UsersDetail}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/bitacora-de-accesos"
							component={RecordsList}
						/>
					</div>
				) : (
					''
				)}
				{authentication.hasRole(['RESPONSABLE DE NEGOCIO'], user) ? (
					<div>
						<ContentRoute
							path="/administracion-de-usuarios/reportes"
							component={Reports}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/bitacora-de-accesos"
							component={RecordsList}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/usuario/:id"
							component={UsersDetail}
						/>
						<ContentRoute
							path="/administracion-de-usuarios/editar-usuario"
							component={Consult}
						/>
					</div>
				) : (
					''
				)}
			</React.Fragment>
		</Switch>
	);
};

export default UsersManagementPage;
